module.exports = __webpack_public_path__ + "img/hdjs.915fa7ef.png";